import State from '../state';
import { generateRandom } from '../utils/common';
import { getEndSource, getPeekSource, getStartSource, passSessionIdToSDK, } from '../utils/khazaddumbridge';
import BaseEvent from './BaseEvent';
export var SessionMode;
(function (SessionMode) {
    SessionMode["HIGHLIGHTS"] = "HIGHLIGHTS";
})(SessionMode || (SessionMode = {}));
class HighlightEvent extends BaseEvent {
    constructor() {
        super(...arguments);
        this.highlightsSessionId = parseInt(generateRandom(18), 10);
        this.startSource = getStartSource();
        this.endSource = getEndSource();
        this.highlightsMode = SessionMode.HIGHLIGHTS;
        this.eventName = "highlights_event" /* HIGHLIGHTS */;
    }
    setupEvent(bubbleId) {
        this.startTime = Date.now();
        this.peekSource = getPeekSource();
        this.startBubble = bubbleId;
        passSessionIdToSDK(this.highlightsSessionId);
    }
    highlightEnd(bubbleId) {
        this.endTime = Date.now();
        this.duration = this.endTime - this.startTime;
        this.endBubble = bubbleId;
        this.glanceStartedCount = State.seenBubles.size;
        this.peekStartedCount = State.interactedGlances.size;
        this.totalBubbleCount = State.loadedBubbles.size;
        this.bubbleStartedCount = State.seenBubles.size;
    }
    reset(bubbleId) {
        this.highlightsSessionId = parseInt(generateRandom(18), 10);
        this.startTime = Date.now();
        this.startSource = getStartSource();
        this.peekSource = getPeekSource();
        this.startBubble = bubbleId;
        passSessionIdToSDK(this.highlightsSessionId);
    }
}
const highlightEvent = new HighlightEvent();
export default highlightEvent;
//# sourceMappingURL=HighlightEvent.js.map